// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"48f392c8","288":"a61d2653","360":"0529f9ee","384":"5adc7947","392":"a1564e25","560":"fc295593","576":"9707c59b","592":"3c94069d","624":"d29f65c9","864":"7e9fd7e1","880":"4908b5ca"}[chunkId] + ".chunk.js";
};